import {Box, Flex, GridItem, SimpleGrid, Text} from '@chakra-ui/react';
import {colors} from 'components/providers';
import {Checkbox} from 'components/shared';
import {useRouter} from 'next/router';
import {FC} from 'react';
import {FilterListTypes} from 'types';

interface Props {
  onChange: (value: FilterListTypes) => void;
  filtersList?: string | string[];
  title: string;
  typeList: {
    name: {en: string; ru: string; ro: string};
    label: string;
  }[];
}

export const TypeFilters: FC<Props> = ({onChange, filtersList, typeList, title}) => {
  const {locale} = useRouter();
  const currentLang = locale as 'ru' | 'ro' | 'en';

  return (
    <Box bg={colors.white} px={['10px', '30px']} borderTopRadius="16px">
      <Text fontSize="16px" fontWeight="bold" my="15px">
        {title}:
      </Text>
      <SimpleGrid as="ul" columns={[1, 2]} columnGap="30px" flexWrap="wrap" justifyContent="space-between">
        {typeList.map((item, index) => {
          const isChecked = filtersList === item.label;
          return (
            <GridItem listStyleType="none" key={index}>
              <Flex borderTop="1px solid" borderColor={colors.borderGray} py="15px">
                <Checkbox
                  onChange={() => onChange(item.label as FilterListTypes)}
                  isChecked={isChecked}
                  variant="circle"
                  display="flex"
                  flexDirection={['row-reverse', 'row']}
                  justifyContent={['space-between', 'flex-start']}
                  w={['100%', 'auto']}
                  m={['0px', '-webkit-fill-available']}
                >
                  <Text fontSize="15px" fontWeight="500" ml={['-15px', '0px']}>
                    {item.name[currentLang]}
                  </Text>
                </Checkbox>
              </Flex>
            </GridItem>
          );
        })}
      </SimpleGrid>
    </Box>
  );
};
